(function($, window, document, undefined) {
  "use strict";

  var pluginName = 'factsAndFigures',
    defaults = {
      countUp: {
        useEasing: true,
        useGrouping: true,
        separator: '.',
        decimal: ',',
        suffix: ''
      }
    };

  // The actual plugin constructor
  function Plugin(element, options) {
    this.element = element;
    this.$element = $(element);
    this.options = $.extend({}, defaults, options);
    this.headerHeight = 0;
    this.ticking = false;
    this.pureNumberElements = '';
    this.fontOverrideClass = 0;
    this.maxFontOverrides = 4;
    this.isStatic = this.$element.data('disableAnimation') || false;
    this.isIE11 = $('html').hasClass('ie11');

    this.init();
  }

  // methods
  var methods = {
    init: function() {
      this.setWrapperClasses();
      this.setupFontsizeOverride();
      this.setupFigures();
      this.setViewportHandler();
      this.initEventHandling();
      this.allDone();
    },

    // set additional classes to wrapper element
    setWrapperClasses: function() {
      this.figuresElement = this.$element.find('.figures__figure');
      var figuresCount = this.figuresElement.length;
      var circleElements = this.$element.find('[data-type="circle"]');
      this.pureNumberElements = this.$element.find('[data-type="pureNumber"]');
      var modiefierClass = 'figures--1inRow';

      if (figuresCount > 2 || circleElements.length) {
        modiefierClass = 'figures--3inRow';
      } else if (figuresCount > 1) {
        modiefierClass = 'figures--2inRow';
      }

      this.$element.addClass(modiefierClass);
    },

    setupFontsizeOverride: function() {
      if (this.pureNumberElements.length) {
        this.cloneOriginalNumber();
        this.checkFontSize();
      }
    },

    setupFigures: function() {
      var self = this;

      this.figuresElement.each(function() {
          var $figure = $(this);
          var figureType = $figure.data('type');

          if (figureType === 'pureNumber') {
            self.resetFigure($figure);
          } else if (figureType === 'circle') {
            self.$element.addClass('figures--circle');
            self.resetFigureCircle($figure);
          }
      });
    },

    // clone original as reference
    cloneOriginalNumber: function() {
      this.pureNumberElements.each(function() {
        var $currentFigure = $(this);
        var $originalNumber = $currentFigure.find('.figures__figureNumber');
        var $clonedNumber = $originalNumber.clone();
        $clonedNumber.addClass('figures__figureNumberClone');
        $originalNumber.addClass('figures__figureNumberOriginal');
        $currentFigure.find('.figures__figureInner').append($clonedNumber);
      });
    },


    setViewportHandler: function() {
      this.getHeaderHeight();
    },

    getHeaderHeight: function() {
      this.headerHeight = document.querySelector('.navbar').offsetHeight;
    },

    viewportCheck: function() {
      var self = this;

      // return for static figures wrapper, no need to check the viewport
      if (this.isStatic) {
        return false;
      }

      this.figuresElement.each(function() {
        var element = this;

        // return if animation is disabled for current element
        if (element.dataset.disableAnimation) {
          return true;
        }

        var viewPortsStats = self.inViewport({
          element: element,
          offestTop: self.headerHeight
        });

        if (viewPortsStats.topInViewport && viewPortsStats.scrollTopPercentage > 5) {
          if (element.dataset.type === 'pureNumber') {
            self.startCounting(element);
          } else if (element.dataset.type === 'circle') {
            self.animateCircle(element);
          }
        }
      });

      setTimeout(function() {
          self.ticking = false;
      }, 100);
    },

    animateCircle: function(element) {
      if (!element.classList.contains('figures__figure--circleIsAnimation')) {
        element.classList.add('figures__figure--circleIsAnimation');
        var foreGround = element.querySelector('.circle__foreground');
        var endPercentage = element.dataset.endPercentage;
        foreGround.setAttribute('stroke-dasharray', endPercentage + ', 100');
      }
    },

    inViewport: function(options) {

      var viewportStats = {
        topInViewport: false,
        bottomInViewport: false,
        topAndBottomInViewport: false,
        isOversized: false,
        scrollTopPercentage: -1
      }

      var addOffsetTop = options.offestTop || 0;
      var addOffsetBottom = options.offestBottom || 0;

      var scrollTop = window.pageYOffset | document.body.scrollTop;
      var documentHeight = window.innerHeight;
      var elementTop = options.element.getBoundingClientRect().top + scrollTop;
      var elementHeight = options.element.offsetHeight;
      var elementBottom = elementTop + elementHeight + addOffsetBottom;
      var scrollTopWithOffset = scrollTop + addOffsetTop;

      viewportStats.topInViewport = elementTop >= scrollTopWithOffset && (scrollTop + documentHeight) >= elementTop;
      viewportStats.bottomInViewport = elementBottom >= scrollTopWithOffset && (scrollTop + documentHeight) >= elementBottom;

      var isOversizedVisible = elementTop < scrollTopWithOffset && (scrollTop + documentHeight) < elementBottom;
      viewportStats.topAndBottomInViewport = viewportStats.topInViewport && viewportStats.bottomInViewport || isOversizedVisible;
      viewportStats.isOversized = elementHeight > documentHeight - addOffsetTop - addOffsetBottom;

      var elementRalativeTop = elementTop - scrollTopWithOffset;
      var documentRelativeBottom = documentHeight - addOffsetBottom;

      if (elementTop - scrollTop <= (documentHeight - addOffsetBottom) && elementRalativeTop > 0) {
        const perc = Math.round(((elementRalativeTop)*100) / (documentRelativeBottom - addOffsetTop));
        const percInverted = Math.abs(perc - 100);
        viewportStats.scrollTopPercentage = percInverted;
      }

      return viewportStats;
    },

    initEventHandling: function() {
      this.addResizeHandler();

      if (!this.isStatic) {
        this.addScrollHandler();
      }
    },

    addScrollHandler: function() {
      var self = this;

      window.addEventListener('scroll', function() {
        self.requestTick();
      });
    },

    addResizeHandler: function() {
      var self = this;

      $(window).on('debouncedwidth', function() {
        if (self.pureNumberElements) {
          self.$element.removeClass('figures--fontSizeOverride-1 figures--fontSizeOverride-2 figures--fontSizeOverride-3 figures--fontSizeOverride-4');
          self.fontOverrideClass = 0;
          self.checkFontSize();
        }
      });
    },

    requestTick: function() {
      if (!this.ticking) {
        window.requestAnimationFrame(this.viewportCheck.bind(this));
      }

      this.ticking = true;
    },

    resetFigureCircle: function($figure) {
      var endValue = $figure.data('endValue');
      var floatCheck = endValue.toString().split('.');

      if (floatCheck.length > 1 && this.options.countUp.decimal === ',') {
        var localizedNumber = endValue.toString().replace('.', ',');
        $figure.find('.figures__figurePureNumber').text(localizedNumber);
      }

      if (this.isIE11) {
        this.isStatic = true;
      }

      if ($figure.data('reset') !== 'true') {
        var startPercentage = $figure.data('startValue') || 0;
        var scale = $figure.data('scale') || 100;
        var endPercentage = Math.round(100 * endValue / scale);

        if (startPercentage !== 0) {
          startPercentage = Math.round(100 * startPercentage / scale);
        }

        if (this.isStatic || $figure.data('disableAnimation')) {
          startPercentage = endPercentage;
          $figure.addClass('figures__figure--static');
        }

        $figure.find('.circle__foreground').attr('stroke-dasharray', startPercentage + ', 100');
        $figure.data('reset', 'true');
        $figure.attr('data-end-percentage', endPercentage);
      }
    },

    resetFigure: function($figure) {
      if ($figure.data('reset') !== 'true') {

        if (this.isStatic || $figure.data('disableAnimation')) {
          $figure.addClass('figures__figure--static');
        } else {
          var startValue = $figure.data('startValue') || 0;
          $figure.find('.figures__figureNumberOriginal .js-countingNumber').text(startValue);
        }

        $figure.data('reset', 'true');
      }
    },

    startCounting: function(figure) {
      if (figure.dataset.isCounting !== 'true') {
        var endValue = figure.dataset.endValue;
        var countElement = figure.querySelector('.figures__figureNumberOriginal .js-countingNumber');
        var lineElement = figure.querySelector('.figures__figureLine');
        var startValue = figure.dataset.startValue || 0;
        var duration = figure.dataset.duration || 4;
        var dezimals = 0;
        var floatCheck = figure.dataset.endValue.split('.');

        if (floatCheck.length > 1) {
          dezimals = floatCheck[1].length;
        }

        if (figure.dataset.disableGrouping) {
          this.options.countUp.useGrouping = false;
        }

        var countUp = new CountUp(countElement, startValue, endValue, dezimals, duration, this.options.countUp);

        lineElement.style.transitionDuration = duration + 's';
        figure.classList.add('figures_figureAnimationDone');
        countUp.start(function() {});

        figure.dataset.isCounting = 'true';
      }
    },

    checkFontSize: function() {
      var needsFontResize = false;

      this.pureNumberElements.each(function() {
        var outerWidth = $(this).find('.figures__figureInner').width();
        var innerWidth = $(this).find('.figures__figureNumberClone')[0].scrollWidth;

        if (innerWidth > outerWidth) {
          needsFontResize = true;
          return false;
        }
      });

      if (needsFontResize) {
        this.overrideFontsize();
      }
    },

    overrideFontsize: function() {
      if (this.fontOverrideClass < this.maxFontOverrides) {
        this.$element.removeClass('figures--fontSizeOverride-' + this.fontOverrideClass);
        this.fontOverrideClass++
        this.$element.addClass('figures--fontSizeOverride-' + this.fontOverrideClass);
        this.checkFontSize();
      }
    },

    allDone: function() {
      var self = this;
      this.$element.removeClass('invisible');

      window.setTimeout(function() {
        self.viewportCheck();
      }, 200);
    }
  };

  $.extend(Plugin.prototype, methods);
  $.fn[pluginName] = function(options) {
    return this.each(function() {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
      }
    });
  };
})(jQuery, window, document);
